module.exports = __webpack_public_path__ + "img/cnu_gallery11.f8d0b81e.jpg";